import genders, {defaultGender} from "../../constants/genders"

export const getPronounFromGender = (gender: string) => {
  const selectedGender = genders.find((genderItem) => genderItem.initial === gender)
  if (!selectedGender) {
    return defaultGender.pronoun
  }
  return selectedGender.pronoun
}
